export enum ShoppingCartItemType {
  GiftCard = 1,
  Bundle = 2,
}

export interface CurrencyDto {
  id: string | null;
  name: string | null;
  code: string | null;
  symbol: string | null;
  decimalPrecision: number | null;
  published: boolean;
}

export interface ExchangeRateToIrrResponse {
  fromCurrencyId: string;
  toCurrencyId: string;
  buyRate: string;
}

export interface PricingAdjustmentResponse {
  calculationType: number | null;
  value: string;
}

export interface BundleGiftCardResponse {
  serviceProviderItemId: string;
  providerEnglishName: string | null;
  providerLogoUrl: string | null;
  serviceName: string | null;
  currency: CurrencyDto;
  amount: string;
  exchangeRateToIrr: ExchangeRateToIrrResponse;
  commission: PricingAdjustmentResponse;
}

export interface GiftCardShoppingCartItemResponse {
  serviceProviderItemId: string;
  providerEnglishName: string | null;
  providerLogoUrl: string | null;
  serviceName: string | null;
  currency: CurrencyDto;
  amount: string;
  quantity: number;
  exchangeRateToIrr: ExchangeRateToIrrResponse;
  commission: PricingAdjustmentResponse;
  discount: PricingAdjustmentResponse;
}

export interface BundleShoppingCartItemResponse {
  bundleId: string;
  bundleName: string | null;
  logoUrl: string | null;
  serviceNames: string[] | null;
  giftCardCount: number;
  quantity: number;
  discount: PricingAdjustmentResponse;
  giftCards: BundleGiftCardResponse[] | null;
}

export interface ShoppingCartItemResponse {
  shoppingCartItemId: string;
  itemType: ShoppingCartItemType;
  giftCard: GiftCardShoppingCartItemResponse | null;
  bundle: BundleShoppingCartItemResponse | null;
}

export interface GetShoppingCartResponse {
  showCommission?: boolean;
  shoppingCartId: string | null;
  totalItemCount: number;
  cartExpiresAt: string | null;
  token: string;
  expireInSecond: number;
  expireAt: string;
  rialCurrency: CurrencyDto;
  items: ShoppingCartItemResponse[] | null;
}

export interface AddGiftCardToShoppingCartRequest {
  amount: string | null;
}
